import{a as n}from"./chunk-RAAYCPUM.js";function d(...r){return n(i,r)}var i=(r,t)=>{let a=[[],[]];for(let[o,e]of r.entries())t(e,o,r)?a[0].push(e):a[1].push(e);return a};export{d as a};
